// extracted by mini-css-extract-plugin
export default {"table":"CustomDataForms_table__QOfW7","tableRow":"CustomDataForms_tableRow__QXeC0"};